<template>
    <v-layout justify-center style="margin-bottom: 100px" class="v-responsive">
        <v-flex xs12 sm10 class="v-responsive__content">
            <v-data-table
                    :items="allRiskpoint"
                    id="customer-table"
                    style="text-align: center"
                    :class="{'customer-table-sm': $vuetify.breakpoint.smAndDown }"
                    class="mt-2 mb-5"
                    v-if="typetable == true"
                    :options.sync="Pagination"
                    hide-default-header
                    >
                <!--                        @page-count="pageCount = $event"-->
                <template v-slot:header="">
                    <tr>
                        <th rowspan="2">ลำดับ</th>
                        <th rowspan="2">พื้นที่</th>
                        <th rowspan="2">เขต</th>
                        <th rowspan="2">แขวง</th>
                        <th colspan="9">จำนวนผู้เสียชีวิต</th>
                    </tr>
                    <tr>
                        <th>55</th>
                        <th>56</th>
                        <th>57</th>
                        <th>58</th>
                        <th>59</th>
                        <th>60</th>
                        <th>61</th>
                        <th>62</th>
                        <th>ทั้งหมด</th>
                    </tr>
                </template>
                <template v-slot:item="{item,index}" >
                    <tr style=" font-size: 10px;"
                            @click="onTable(item.id,item.name_riskpoint,item.latitude_center,item.longitude_center)">
                        <td style="text-align: center;"
                        >{{ ((Pagination.page - 1) * Pagination.itemsPerPage) + index + 1 }}</td>
                        <td style="text-align: left;"
                        >{{item.name_riskpoint  ? (item.name_riskpoint):'-'}}</td>
                        <td
                        >{{item.district ? (item.district):'-'}}</td>
                        <td
                        >{{item.subdistrict ? (item.subdistrict):'-'}}</td>
                        <td
                        >{{item.Y2555 ? (item.Y2555):'-'}}</td>
                        <td
                        >{{item.Y2556 ? (item.Y2556):'-'}}</td>
                        <td
                        >{{item.Y2557 ? (item.Y2557):'-'}}</td>
                        <td
                        >{{item.Y2558 ? (item.Y2558):'-'}}</td>
                        <td
                        >{{item.Y2559 ? (item.Y2559):'-'}}</td>
                        <td
                        >{{item.Y2560 ? (item.Y2560):'-'}}</td>
                        <td
                        >{{item.Y2561 ? (item.Y2561):'-'}}</td>
                        <td
                        >{{item.Y2562 ? (item.Y2562):'-'}}</td>
                        <td style="text-align: center;border-right: white"
                        >{{item.summary_riskpoint}}</td>
                    </tr>
                </template>
            </v-data-table>
            <v-simple-table
                    id="customer-table"
                    v-if="typetable == false"
                    class="mt-2 mb-5"
                    :class="{'customer-table-sm': $vuetify.breakpoint.smAndDown }"
                    style="text-align: center"
            ><!--            v-if="$vuetify.breakpoint.mdAndUp"-->
                <!--                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size':'18px'}:{'font-size':'14px'}">-->
                <template>
                    <thead>
                    <tr>
                        <th
                        >ลำดับ</th>
                        <th style="width: 20%"
                        >พื้นที่</th>
                        <th
                        >เขต</th>
                        <th
                        >แขวง</th>
                        <th
                        >2555</th>
                        <th
                        >2556</th>
                        <th
                        >2557</th>
                        <th
                        >2558</th>
                        <th
                        >2559</th>
                        <th
                        >2560</th>
                        <th
                        >2561</th>
                        <th
                        >2562</th>
                        <th
                        >จำนวนผู้เสียชีวิต</th>
                    </tr>
                    </thead>
                    <tbody style="font-size: 10px">
                    <tr v-for="(item,i) in allRiskpoint" :key="i"
                        @click="onTable(item.id,item.name_riskpoint,item.latitude_center,item.longitude_center)"
                    >
                        <td style="text-align: center;"

                        >{{i+1}}</td>
                        <td style="text-align: left; font-size: 10px;"
                        >{{item.name_riskpoint  ? (item.name_riskpoint):'-'}}</td>
                        <td
                        >{{item.district ? (item.district):'-'}}</td>
                        <td
                        >{{item.subdistrict ? (item.subdistrict):'-'}}</td>
                        <td
                        >{{item.Y2555 ? (item.Y2555):'-'}}</td>
                        <td
                        >{{item.Y2556 ? (item.Y2556):'-'}}</td>
                        <td
                        >{{item.Y2557 ? (item.Y2557):'-'}}</td>
                        <td
                        >{{item.Y2558 ? (item.Y2558):'-'}}</td>
                        <td
                        >{{item.Y2559 ? (item.Y2559):'-'}}</td>
                        <td
                        >{{item.Y2560 ? (item.Y2560):'-'}}</td>
                        <td
                        >{{item.Y2561 ? (item.Y2561):'-'}}</td>
                        <td
                        >{{item.Y2562 ? (item.Y2562):'-'}}</td>
                        <td style="text-align: center;border-right: white"
                        >{{item.summary_riskpoint}}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <!--            <v-pagination-->
            <!--                    v-model="pagination.page"-->
            <!--                    :length="parseInt(allRiskpoint.length/ 10 +1)"-->
            <!--                    :total-visible="pagination.visible"-->
            <!--                    color="#006738"-->
            <!--                    class="mt-7 pagination mb-5"-->
            <!--            ></v-pagination>-->
            <!--            <v-pagination-->
            <!--                    v-model="allRiskpoint"-->
            <!--                    @input="onGetAllRiskpoint"-->
            <!--                    class="mt-7 pagination"-->
            <!--                    color="#006738"-->
            <!--            ></v-pagination>-->
            <!--            <v-row justify="end">-->
            <!--                <v-btn-->
            <!--                        dark-->
            <!--                        style="background-color: #006738"-->
            <!--                        @click="testtable"-->
            <!--                >Export</v-btn>-->
            <!--            </v-row>-->
            <v-row style="max-width: 100%" justify="end">
                <v-btn
                        dark
                        style="background-color: #006738"
                        @click="saveAsExcel"
                        max-width="110px"
                >Export</v-btn>
            </v-row>
        </v-flex>
        <!--        <v-flex class="mt-6" v-else>-->
        <!--        <v-simple-table id="customer-table">-->
        <!--            <template>-->
        <!--                <thead>-->
        <!--                <tr>-->
        <!--                    <th width="8%">ลำดับ</th>-->
        <!--                    <th>พื้นที่</th>-->
        <!--                    <th width="25%" >จำนวนผู้เสียชีวิต</th>-->
        <!--                </tr>-->
        <!--                </thead>-->
        <!--                <tbody>-->
        <!--                <tr v-for="(item,i) in allRiskpoint.data" :key="i" @click="onTable">-->
        <!--                    <td style="text-align: center">{{ ((allRiskpoint.current_page - 1) * allRiskpoint.per_page) + i + 1  }}</td>-->
        <!--                    <td class="pl-8">{{item.name_riskpoint}}</td>-->
        <!--                    <td style="text-align: center;border-right: white">{{item.summary_riskpoint}}</td>-->
        <!--                </tr>-->
        <!--                </tbody>-->
        <!--            </template>-->
        <!--        </v-simple-table>-->
        <!--    </v-flex>-->
    </v-layout>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import XLSX from 'xlsx'
    export default {
        name: "TableRisk",
        data: ()=>({
            typetable: true,
            Pagination: {
                page: 1,
                itemsPerPage: 10
            }
        }),
        created() {
            if (!this.selectedDistrict) {
                this.onGetAllRiskpoint();
            }
        },
        computed: {
            ...mapState({
                allRiskpoint: state => state.riskpoint.allRiskpoint,
                pageriskpoint: state => state.riskpoint.pageriskpoint,
                alldatachart: state => state.datachart.alldatachart,
                selectedDistrict: state => state.riskpoint.selectedDistrict
            })
        },
        watch: {
        },
        methods: {
            ...mapActions('riskpoint', ['onGetRiskpointdatetime','onGetAllRiskpoint']),
            ...mapActions('patient', ['onGetPatient','onGetPatientdatetime']),
            ...mapActions('datachart', ['onGetDatachart']),
            async onTable(id,location,centerlet,centerlng) {
                this.onGetPatient(id);
                await this.onGetDatachart(id)
                this.$router.push({ name: 'Patient', params: { riskpoint : location,oncenterlet : centerlet , oncenterlng : centerlng } });
                // this.$router.push("/patient");

            },
            testtable() {
                this.typetable = false;
            },
            async saveAsExcel() {
                await this.testtable();
                let workbook = XLSX.utils.book_new();

                //var worksheet_data  =  [['hello','world']];
                //var worksheet = XLSX.utils.aoa_to_sheet(worksheet_data);



                let worksheet_data  = document.getElementById("customer-table");
                let worksheet = XLSX.utils.table_to_sheet(worksheet_data);



                workbook.SheetNames.push("Riskpoint");
                workbook.Sheets["Riskpoint"] = worksheet;
                this.typetable = true;
                return XLSX.writeFile(workbook, "AllRiskpoints.xlsx");


            },


        },
    }

</script>

<style scoped>
    #customer-table tbody tr:hover{
        color: #006738;
        background-color: white;
        text-decoration: underline;
        font-weight: bold;
        user-select: none;
        cursor: pointer;
    }
</style>
